module.exports = __webpack_public_path__ + "img/valores-pensar-e-agir.e217a696.svg";